
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap&-autoprefixer!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-887da7c8!sass-loader?sourceMap!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./NotificationTooltip.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./NotificationTooltip.vue"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-887da7c8!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./NotificationTooltip.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./client/components/Misc/NotificationTooltip.vue
// module id = 128
// module chunks = 0